const CleanFileIcon = ({ color = "var(--border)", width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 500.696 500.696"
      xmlSpace="preserve"
      width={width}
      height={height}>
      <g>
        <path
          fill={color}
          d="M121.232,158.288l-44.245,12.971c-29.073,8.534-53.191,28.949-66.411,56.213c-13.001,26.894-14.062,58.022-2.923,85.739   c0.149,0.384,0.341,0.747,0.491,1.131l36.693-5.995c34.585-9.008,66.21-26.909,91.733-51.925c8.424-8.247,21.939-8.104,30.187,0.32   c8.247,8.424,8.104,21.939-0.32,30.187l0,0c-31.413,30.663-70.388,52.458-112.96,63.168l-25.003,4.139   c14.387,23.381,32.224,44.455,52.907,62.507l43.797-16.256l29.867-14.933c30.789-15.473,57.148-38.506,76.608-66.944l11.072-16.235   c6.366-9.914,19.563-12.791,29.478-6.426c9.914,6.366,12.791,19.563,6.426,29.478c-0.211,0.329-0.432,0.652-0.661,0.969   l-11.051,16.235c-23.54,34.447-55.452,62.343-92.736,81.067l-33.067,16.491l-17.984,6.656   c43.341,25.268,92.636,38.524,142.805,38.4h19.712c4.411-0.003,8.714-1.358,12.331-3.883   c45.181-30.707,82.597-71.506,109.291-119.168L174.906,134.053C157.952,144.064,139.953,152.19,121.232,158.288z"
        />
        <path
          fill={color}
          d="M494.373,21.755c-8.433-8.403-22.074-8.403-30.507,0L362.234,123.387l-6.827-6.677   c-37.156-36.291-95.028-40.603-137.152-10.219c-1.963,1.408-3.904,2.581-5.888,3.947l213.909,210.005   c6.807-18.43,11.808-37.478,14.933-56.875c5.368-34.287-6.181-69.052-30.997-93.312l-17.067-16.725L494.416,52.261   C502.807,43.817,502.788,30.176,494.373,21.755z"
        />
      </g>
    </svg>
  );
};

export default CleanFileIcon;
